import { Inject, Injectable, Injector } from '@angular/core';
import { find, isString } from 'lodash';

import { CalculationService } from './calculation.types';
import { CALCULATION_VERSIONS } from './calculation.enums';

@Injectable()
export class StandWorksheetCalcServiceProvider {
  public fallbackServiceClass: CalculationService = this.getServiceClass(
    CALCULATION_VERSIONS.V1,
  );

  public constructor(
    public injector: Injector,
    @Inject('CalculationServices') public calculationServices,
  ) {}

  public getServiceClass(
    predicate: CALCULATION_VERSIONS | Object,
  ): CalculationService {
    const findCriteria = isString(predicate)
      ? { VERSION: predicate }
      : predicate;

    return find(this.calculationServices, findCriteria);
  }

  public getService(
    predicate: CALCULATION_VERSIONS | Object,
  ): CalculationService {
    const serviceClass =
      this.getServiceClass(predicate) || this.fallbackServiceClass;
    const service = this.injector.get(serviceClass);

    return service;
  }
}
